import React, {useState} from "react";
import {PROGRAM_ASSOCIATION_LABEL} from "../../constants";
import UserForm from "../../components/userForm";
import Input from "../../components/common/input";
import Selector from "../../components/common/selector";

const ROLES = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Counselor',
    value: 1
  },
  {
    label: 'Teacher',
    value: 2
  },
  {
    label: 'School Administrator',
    value: 3
  },
  {
    label: 'District Administrator',
    value: 4
  },
  {
    label: 'Academic Prep Partner',
    value: 5
  },
  {
    label: 'Registrar',
    value: 6
  },
  {
    label: 'Other',
    value: 7
  }
];

const PROGRAMS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'Program 1',
    value: 1
  },
  {
    label: 'Program 2',
    value: 2
  },
  {
    label: 'Program 3',
    value: 3
  },
  {
    label: 'Program 4',
    value: 4
  },
  {
    label: 'Program 5',
    value: 5
  },
  {
    label: 'Program 6',
    value: 6
  },
  {
    label: 'Program 7',
    value: 7
  },
  {
    label: 'Other',
    value: 8
  }
];

const CreateUserInfo = (props) => {
  const {
    errors,
    onSubmitAction,
    onCancelAction,
  } = props;

  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [role, setRole] = useState('');
  const [programAssociation, setProgramAssociation] = useState('');

  const handleKeyDown = (event) => {
    if(event.key === 'Enter'){
      submitAction(event.target.value);
    }
  }

  const submitAction = () => {
    onSubmitAction(
      {
        email: email,
        firstName: firstName,
        lastName: lastName,
        role: role,
        programAssociation: programAssociation
      }
    )
  };

  return (
    <UserForm formTitle='User Info' hideTitle={true} submitAction={submitAction} cancelAction={onCancelAction} submitLabel='Next' disabled={false}>
      <div className='form-required'>
        * Indicates Required Fields
      </div>
      <Input
        name='email'
        id='email'
        value={email}
        label='Email*'
        type='text'
        autoComplete='email'
        changeAction={setEmail}
        errors={errors?.email}
      />
      <Input
        name='firstName'
        id='firstName'
        value={firstName}
        label='First Name*'
        type='text'
        onKeyDown={handleKeyDown}
        autoComplete='given-name'
        changeAction={setFirstName}
        errors={errors?.firstName}
      />
      <Input
        name='lastName'
        id='lastName'
        value={lastName}
        label='Last Name*'
        type='text'
        onKeyDown={handleKeyDown}
        autoComplete='family-name'
        changeAction={setLastName}
        errors={errors?.lastName}
      />
    </UserForm>
  );
}

export default CreateUserInfo;